var _path, _circle, _circle2, _rect, _rect2, _circle3, _circle4, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 256,
    height: 256,
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.75h8l2.25 2.25v10.5a2.5 2.5 0 0 1-2.5 2.5h-7.5a2.5 2.5 0 0 1-2.5-2.5V5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6,
    cy: 4.9,
    r: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 4.9,
    r: 0.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 7.4,
    width: 3.6,
    height: 3.6,
    rx: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: 7.4,
    width: 3.6,
    height: 3.6,
    rx: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 14.1,
    r: 1.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9,
    cy: 14.1,
    r: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 14.3h1.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18 3 22.25M16.5 18 21 22.25M6.4 19.4h11.2M5 20.85h14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrain);
export default __webpack_public_path__ + "static/media/icon-train.8a56f09062c541c0ee881b83623b845d.svg";
export { ForwardRef as ReactComponent };